var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoxbm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.46+435.748L418.019+415.67L419.923+384.688L437.578+368.764",
    stroke: "#000000",
    strokeWidth: 4.39629,
    fill: "none",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.847+458.25L455.405+438.172L457.309+407.189L474.964+391.265",
    stroke: "#000000",
    strokeWidth: 4.39629,
    fill: "none",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.979+434.537L437.751+456.173L419.576+414.978L456.271+437.479L421.654+385.38L458.694+405.977L437.578+369.456L474.445+392.823",
    stroke: "#000000",
    strokeWidth: 4.39629,
    fill: "none",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.46+435.748L418.019+415.67L419.923+384.688L437.578+368.764",
    stroke: "#000000",
    strokeWidth: 4.39629,
    fill: "none",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07911+17.5393L20.6188+10.9544L31.5614+16.926L20.4897+23.6884",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6589+9.84162L32.4642+4.11284L42.7388+10.1076L33.4421+15.8189",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2638+16.9052L44.5959+11.198L55.1309+17.3488L46.1136+22.8757",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7588+39.1164L33.0725+32.4517L44.6042+38.8077L32.5459+45.5814",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0714+25.6774L32.2601+18.5011L32.0453+30.9073L20.7272+37.7164",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2354+24.4335L56.4505+18.7572L56.3514+32.1341L46.9058+37.4491",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8418+39.7108L56.3566+34.3671L56.4143+45.8619L46.515+51.5324",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6908+47.111L44.9667+40.7965L44.7179+52.5596L33.5672+58.889",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6718+40.8012L31.8766+47.2736L31.6567+59.2531L20.3992+52.6307",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34276+33.4644L18.8363+39.5617L18.4386+51.5132L8.21021+45.8357",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38866+19.1378L19.3672+25.1781L19.0069+37.5343L8.43105+31.3668",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1255+18.2245L45.4263+24.5215L45.0515+36.928L33.9569+30.8746",
    opacity: 1,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoxbm);
export default __webpack_public_path__ + "static/media/voxbm.b6dd4c139b70ba3ad5b8d5e04aea4e00.svg";
export { ForwardRef as ReactComponent };